import { Component, Output, EventEmitter, Input, OnInit, } from '@angular/core';
import { SaveService } from '../../services/save.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

	@Output() mxSalvar: EventEmitter<any> = new EventEmitter<any>();
	@Input() disabledSalvar = false;

	@Output() mxVoltar: EventEmitter<any> = new EventEmitter<any>();

	@Output() mxExcluir: EventEmitter<any> = new EventEmitter<any>();
	@Input() disabledExcluir = false;

	constructor(public readonly saveService: SaveService) { }

	ngOnInit(): void {
		if (this.mxExcluir.observers.length === 0) {
			this.mxExcluir = null;
		}
		if (this.mxVoltar.observers.length === 0) {
			this.mxVoltar = null;
		}
	}

	salvar() {
		this.saveService.saving = true;
		this.mxSalvar.emit();
	}

	voltar() {
		if (this.mxVoltar) {
			this.mxVoltar.emit();
		}
	}

	excluir() {
		if (this.mxExcluir) {
			this.saveService.saving = true;
			this.mxExcluir.emit();
		}
	}

}
